import { type FormSubmission, type Stored } from "@overmap-ai/common"
import { selectFormById, selectFormSubmissions } from "@overmap-ai/core"
import { ReactRenderer } from "@tiptap/react"

import { appStore } from "../../../../store"
import type { MentionListRootProps } from "../../../blocks/MentionList/Root"
import type { MentionListRef } from "../../../blocks/MentionList/typings"
import { FormSubmissionMentionList } from "../../../components/MentionLists"
import type { SuggestionOptions } from "../typings"
import { updatePosition } from "../utils"

export const suggestion: SuggestionOptions<Stored<FormSubmission>> = {
	char: "@f",
	items: ({ query }) => {
		const formSubmissions = selectFormSubmissions(appStore.getState())

		return formSubmissions
			.filter((submission) => {
				const form = selectFormById(submission.form)(appStore.getState())
				const formName = form?.name ?? "Untitled form submission"
				return formName.toLowerCase().startsWith(query.toLowerCase())
			})
			.slice(0, 10)
	},

	render: () => {
		let component: ReactRenderer<
			MentionListRef<Stored<FormSubmission>>,
			MentionListRootProps<Stored<FormSubmission>>
		>

		return {
			onStart: (props) => {
				component = new ReactRenderer(FormSubmissionMentionList, {
					props,
					editor: props.editor,
					as: "div",
				})

				if (!props.clientRect) {
					return
				}

				;(component.element as HTMLElement).style.position = "fixed"
				component.element.setAttribute("data-floating-content", "")

				document.body.appendChild(component.element)

				updatePosition(props.editor, component.element as HTMLElement)
			},

			onUpdate(props) {
				component.updateProps(props)

				if (!props.clientRect) {
					return
				}

				updatePosition(props.editor, component.element as HTMLElement)
			},

			onKeyDown(props) {
				if (props.event.key === "Escape") {
					component.destroy()

					return true
				}

				return component.ref?.onKeyDown?.(props) ?? false
			},

			onExit() {
				component.element.remove()
				component.destroy()
			},
		}
	},
}
